export function objectsearch() {
	if (typeof allObjects === 'undefined')
		return;

	let subArray = [];
	for (let i = 0; i < 100; i++) {
		subArray[i.toString()] = 0;
	}

	let finalObjectsForSearch = [];

	allObjects.forEach((e) => {
		if(subArray[e.rooms.toString()] < 30000) {
			subArray[e.rooms.toString()] = subArray[e.rooms.toString()] + 1;
			finalObjectsForSearch.push(e);
		}
	})

	let counter = 0;
	let elementsPerPage = 100000;

	finalObjectsForSearch.sort((a,b) =>  {
		return a.availability.localeCompare(b.availability);
	});

	finalObjectsForSearch.forEach((e) => {
		let object =
			`
				<div data-page="${Math.floor(counter / elementsPerPage) + 1}" class="object-list__object" data-rooms="${e.rooms}" data-space="${e.livingSpace}" data-availability="${e.availability}" ${ e.price > 0 && e.availability == "available" ? 'data-price="' + e.price + '"' : ''}">
					<div class="object-list__object__heading">
						${e.availability === "available" ? '<img src="/assets/images/Icon_verfuegbar.svg" alt="Verfügbar"/>' : ''}
						${e.availability === "reserved" ? '<img src="/assets/images/Icon_reserviert.svg" alt="Reserviert"/>' : ''}
						${e.availability === "sold" ? '<img src="/assets/images/Icon_verkauft.svg" alt="Verkauft"/>' : ''}
						<p>${e.name}</p>
					</div>
					<div class="object-list__object__content">
						<div class='object-list__object__content__details'>
							${e.rooms > 0 ? '<div class="object-detail"><p class="object-detail__head">Zimmer</p><p class="object-detail__value">' + e.rooms + '</p></div>' : ''}
							${e.floors > 0 ? '<div class="object-detail"><p class="object-detail__head">Etage</p><p class="object-detail__value">' + e.floors + '</p></div>' : ''}
							${e.livingSpace > 0 ? '<div class="object-detail"><p class="object-detail__head">Wohnfläche</p><p class="object-detail__value">ca. ' + e.livingSpace + ' m²</p></div>' : ''}
							${e.totalSpace > 0 ? '<div class="object-detail"><p class="object-detail__head">Gesamtfläche</p><p class="object-detail__value">ca. ' + e.totalSpace + ' m²</p></div>' : ''}
							${e.price > 0 && e.availability == "available" ? '<div class="object-detail"><p class="object-detail__head">Preis</p><p class="object-detail__value">' + e.price.toLocaleString('de-DE') + ' €</p></div>' : ''}
							${e.objektnummer ? '<div class="object-detail"><p class="object-detail__head">Objekt-ID</p><p class="object-detail__value">' + e.objektnummer + '</p></div>' : ''}
						</div>
						<div class="object-list__object__content__link">
							<a href="${e.detailLink}" class="button button--primary">zum Angebot</a>
						</div>
					</div>
				</div>
				`;

		$(".object-list").append(object)

		counter++;
	})


	let initialRender = true;

	let currentPage = 1;
	let totalPages;

	let roomFilterValue;
	let sizeFilterValue;
	let priceFilterValue;
	let availabilityFilterValue;

	$(".manual-pagination a").on("click", function(e) {
		e.preventDefault();
		const page = $(this).parent().data("page");

		if(page === "prev") {
			if(currentPage > 1)
				currentPage--;
		}
		else if(page === "next") {
			if(currentPage < totalPages)
				currentPage++;
		}
		else
			currentPage = page;

		const url = new URL(window.location);
		url.searchParams.set("cPage", currentPage);
		window.history.pushState({}, '', url);

		updateLocationResultView()
		scrollTop()
	})

	$("#object-list-filter-button").on("click", function(e) {
		e.preventDefault();

		const url = new URL(window.location);

		const newRoomFilterValue = $("#filter--rooms").val();
		const newSizeFilterValue = $("#filter--size").val();
		const newPriceFilterValue = $("#filter--price").val();
		const newAvailabilityFilterValue = document.getElementById("filter--availability").value;


		if(newRoomFilterValue !== roomFilterValue || newSizeFilterValue !== sizeFilterValue || newPriceFilterValue !== priceFilterValue || newAvailabilityFilterValue !== availabilityFilterValue) {
			currentPage = 1
			url.searchParams.set("cPage", currentPage);
		}

		roomFilterValue = newRoomFilterValue;
		sizeFilterValue = newSizeFilterValue;
		priceFilterValue = newPriceFilterValue;
		availabilityFilterValue = newAvailabilityFilterValue;

		if(roomFilterValue) {
			url.searchParams.set("cRooms", roomFilterValue);
		} else {
			url.searchParams.delete("cRooms");
		}

		if(sizeFilterValue) {
			url.searchParams.set("cSize", sizeFilterValue);
		} else {
			url.searchParams.delete("cSize");
		}

		if(priceFilterValue) {
			url.searchParams.set("cPrice", priceFilterValue);
		} else {
			url.searchParams.delete("cPrice");
		}

		if(availabilityFilterValue && availabilityFilterValue !== "") {
			url.searchParams.set("cAvail", availabilityFilterValue);
		} else {
			url.searchParams.delete("cAvail");
		}

		if(!window.location.toString().includes("/immobilien")) {
			const newPage = encodeURI(url.toString().replace(window.location, window.location + "/immobilien"));
			window.history.pushState({}, '', newPage);
			window.location = newPage;
		} else {
			window.history.pushState({}, '', url);
			updateLocationResultView();
		}
	})

	updateLocationResultView()

	function updateLocationResultView() {
		const urlParams = new URLSearchParams(location.search);

		if(initialRender) {
			if (urlParams.has('cPage')) {
				currentPage = urlParams.get('cPage');
			}

			if (urlParams.has('cRooms')) {
				roomFilterValue = urlParams.get('cRooms');
				$("#filter--rooms").val(roomFilterValue);
			}

			if (urlParams.has('cSize')) {
				sizeFilterValue = urlParams.get('cSize');
				$("#filter--size").val(sizeFilterValue);
			}

			if (urlParams.has('cPrice')) {
				priceFilterValue = urlParams.get('cPrice');
				$("#filter--price").val(priceFilterValue);
			}

			if (urlParams.has('cAvail')) {
				availabilityFilterValue = urlParams.get('cAvail');
				$("#filter--availability").val(availabilityFilterValue);
			}

			initialRender = false;
		}


		let allObjectsInDom = $(".object-list__object");
		allObjectsInDom.addClass("matches-filter");

		if(roomFilterValue && roomFilterValue >= 0) {
			const roomFilterAsInt = parseInt(roomFilterValue);

			allObjectsInDom.each(function() {

				if(typeof $(this).data("rooms") !== 'undefined') {
					const rooms = parseInt($(this).data("rooms"));

					if(rooms < roomFilterAsInt) {
						$(this).removeClass("matches-filter");
					}
				} else {
					$(this).removeClass("matches-filter");
				}
			})
		}

		if(sizeFilterValue && sizeFilterValue >= 0) {
			const sizeFilterAsInt = parseInt(sizeFilterValue);

			allObjectsInDom.each(function() {

				if(typeof $(this).data("space") !== 'undefined') {
					const size = parseInt($(this).data("space"));

					if(size < sizeFilterAsInt) {
						$(this).removeClass("matches-filter");
					}
				} else {
					$(this).removeClass("matches-filter");
				}
			})
		}

		if(priceFilterValue && priceFilterValue >= 0) {
			const priceFilterAsInt = parseInt(priceFilterValue);

			allObjectsInDom.each(function() {

				if(typeof $(this).data("price") !== 'undefined') {
					const price = parseInt($(this).data("price"));

					if(price > priceFilterAsInt) {
						$(this).removeClass("matches-filter");
					}
				} else {
					$(this).removeClass("matches-filter");
				}
			})
		}

		if(availabilityFilterValue && availabilityFilterValue !== "") {
			allObjectsInDom.each(function() {

				if(typeof $(this).data("availability") !== 'undefined') {
					const availability = $(this).data("availability");

					if(availability !== availabilityFilterValue) {
						$(this).removeClass("matches-filter");
					}
				} else {
					$(this).removeClass("matches-filter");
				}
			})
		}


		$(".yn-pagination__page").remove();
		totalPages = Math.ceil($(".object-list__object.matches-filter").length / elementsPerPage);

		let paginationString = '';

		for (let j = 0; j < totalPages; j++) {
			paginationString += '<li class="yn-pagination__page manual-pagination" data-page="' + (j + 1) + '"><a href="#">' + (j+1) + '</a></li>'
		}

		$(".yn-pagination").append($(paginationString));

		$('.manual-pagination[data-page="' + currentPage + '"]').addClass("yn-pagination__page--active");

		$(".yn-pagination__page.manual-pagination a").on("click", function(e) {
			e.preventDefault();
			const page = $(this).parent().data("page");
			currentPage = page;

			const url = new URL(window.location);
			url.searchParams.set("cPage", currentPage);
			window.history.pushState({}, '', url);

			updateLocationResultView()
			scrollTop()
		})


		const objectResults = $(".object-list__object.matches-filter");

		if(objectResults.length > 0) {
			$(".no-results").css("display", "none")
			$(".results").css("display", "block")
		} else {
			$(".no-results").css("display", "block")
			$(".results").css("display", "none")
		}

		for (let i = 0; i < objectResults.length; i++) {
			$(objectResults[i]).attr("data-page", Math.floor(i / elementsPerPage));
		}

		$(objectResults).removeClass("visible");
		$('.object-list__object[data-page="'+ (currentPage - 1) +'"]').addClass("visible");
	}

	function scrollTop() {
		var headerHeight = $("#header").outerHeight();
		var topOffset = $('.object-list-legend').offset().top - headerHeight;

		$('html, body').animate({scrollTop: topOffset}, 500);
	}
}
